import React from 'react'

import { AppProvider } from './src/context'

export default ({ element }) => <AppProvider>{element}</AppProvider>
